module.exports = __webpack_public_path__ + "static/img/ikonaPrezentacjaDisabled-OFF.cf06849f.png";